/**
 * Combined detector with named capture groups.
 *
 * We keep this as a single scanner to avoid overlap & merging complexity
 * that can arise when combining separate regex runs (e.g., URLs containing digits).
 * We still split helper responsibilities into focused utils for clarity.
 */
export const COMBINED_LINK_DETECTION_PATTERN =
  /(?<url>\b(?:(?:https?:\/\/)|(?:www\.))[\w-]+(?:\.[\w-]+)+(?:[^\s"')<>\]]*)?)|(?<email>\b[\w%+.-]+@[\d.A-Za-z-]+\.[A-Za-z]{2,}\b)|(?<phone>\b\+?\d[\d\s().-]{6,}\d\b)/g;
